<template>
    <div>
        <Popup v-if="localStorage"/>
        <div v-else class="wrapper text text--align-center">
            <img class="start-image" :src="require(`@/assets/${currentData.image}`)">
            <p class="margin margin--bottom-10" v-html="currentData.copy"></p>
            <FormTemplate @onValidation="onLocalStorageChange($event)"/>
        </div>
    </div>
</template>
<script>

    import FormTemplate from '@/components/Form.vue'
    import data from '../assets/data/data'
    import Popup from '@/components/Popup.vue'

    export default {
        name: 'Form',
        components: {
            FormTemplate,
            Popup,
        },
        data: function(){
            return {
                data: data,
                localStorage: localStorage.getItem('formSubmitted'),
            }
        },
        methods: {

            onLocalStorageChange: function(){

                this.localStorage = true;
            },
        },

        computed: {

            currentData: function(){
                return this.data.activities[this.$route.params.id].form;
            }
        }
    }

</script>
